import Transform from "@ember-data/serializer/transform";
import ConsultationReportType from "parog-web/models/consultation/consultation-report-type";

interface Serialized {
  id: string;
  enabled: boolean;
}

export default class ConsultationReportTypesTransform extends Transform {
  deserialize(serialized: Serialized[]): ConsultationReportType[] {
    return serialized.map(
      item => new ConsultationReportType(item["id"], item["enabled"])
    );
  }

  serialize(deserialized: ConsultationReportType[]): Serialized[] {
    const result = deserialized.map(item => {
      return {
        id: item.id,
        enabled: item.enabled
      };
    });

    return result;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "consultation-report-types": ConsultationReportTypesTransform;
  }
}
